import { z } from "zod";

export const relationTypeSchema = z.enum(["RELATED", "PREDECESSOR", "DERIVED"]);
export const linkServiceSchema = z.enum([
  "BACKLOG_PROJECT",
  "BACKLOG_ISSUE",
  "KINTONE_APP",
  "KINTONE_RECORD",
  "DRIVE_FOLDER",
  "DRIVE_FILE",
  "GOOGLE_SHEET",
  "GOOGLE_CHAT",
  "URL",
]);
export const linkStatusSchema = z.enum(["UNKNOWN", "OK", "BROKEN", "INACCESSIBLE"]);

/** あるプロジェクトから見た関連(方向を解決済み)。 */
export const projectRelationViewSchema = z.object({
  id: z.string(),
  type: relationTypeSchema,
  /** 見ている側が from か。RELATED では常に true。 */
  forward: z.boolean(),
  otherProjectId: z.string(),
  otherProjectName: z.string(),
  otherProjectStatus: z.enum(["ACTIVE", "ENDED", "ARCHIVED"]),
  note: z.string(),
  revision: z.number(),
});
export type ProjectRelationView = z.infer<typeof projectRelationViewSchema>;
export const projectRelationListResponseSchema = z.object({
  relations: z.array(projectRelationViewSchema),
});
export type ProjectRelationListResponse = z.infer<typeof projectRelationListResponseSchema>;

export const createProjectRelationRequestSchema = z.object({
  toProjectId: z.string().min(1),
  type: relationTypeSchema,
  note: z.string().max(500).default(""),
});
export type CreateProjectRelationRequest = z.infer<typeof createProjectRelationRequestSchema>;

export const externalLinkViewSchema = z.object({
  id: z.string(),
  service: linkServiceSchema,
  externalId: z.string().nullable(),
  displayName: z.string(),
  /** 空なら未設定の枠(ユーザー決定 2026-09-16) */
  url: z.literal("").or(z.url()),
  /** 表示に使うアイコン。空なら URL から自動で決める。`si:<slug>` はブランドのアイコン */
  icon: z.string(),
  /** サイトのアイコン(favicon)を取得した日時(ISO)。画像のキャッシュの目印。取れていなければ null */
  favicon: z.string().nullable(),
  status: linkStatusSchema,
  lastCheckedAt: z.string().nullable(),
  revision: z.number(),
});
export type ExternalLinkView = z.infer<typeof externalLinkViewSchema>;
export const externalLinkListResponseSchema = z.object({ links: z.array(externalLinkViewSchema) });
export type ExternalLinkListResponse = z.infer<typeof externalLinkListResponseSchema>;
export const externalLinkResponseSchema = z.object({ link: externalLinkViewSchema });

export const createExternalLinkRequestSchema = z.object({
  url: z.string().trim().min(1, "URL は必須です").max(2000),
  displayName: z.string().trim().max(200).optional(),
  icon: z.string().trim().max(100).optional(),
});
export type CreateExternalLinkRequest = z.infer<typeof createExternalLinkRequestSchema>;

export const updateExternalLinkRequestSchema = z.object({
  revision: z.number().int().positive(),
  /** 空にすると未設定に戻り、URL のドメインが表示名になる */
  displayName: z.string().trim().max(200),
  /** 省略したら URL は変えない。空にすると未設定の枠に戻る。変えるとサービス種別を判定し直す */
  url: z.string().trim().max(2000).optional(),
  /** 省略したらアイコンは変えない。空にすると自動(URL から判定)に戻る */
  icon: z.string().trim().max(100).optional(),
});
export type UpdateExternalLinkRequest = z.infer<typeof updateExternalLinkRequestSchema>;
